module.exports = __webpack_public_path__ + "img/01.d0fcf223.jpg";